if (window.matchMedia('(min-width: 992px)').matches) {
    let productBoxes = document.querySelectorAll('.product-box-advanced');
    productBoxes.forEach(function (productBox) {
        let sale = productBox.querySelector('.product-box__sale');
        let buttons = productBox.querySelector('.product-box__buttons');
        let variantsSummary = productBox.querySelector('.product-box__variants-summary');
        let variants = productBox.querySelector('.product-box__variants');
        let divider = productBox.querySelector('.product-box__divider');
        let title = productBox.querySelector('.product-box__title');
        let about = productBox.querySelector('.product-box__about');

        productBox.addEventListener('mouseover', () => {
            sale?.classList.add('d-none');
            buttons?.classList.remove('d-none');

            variantsSummary?.classList.add('d-none');
            variants?.classList.remove('d-none');

            divider?.classList.add('d-none');
            title?.classList.add('d-none');
            about?.classList.add('d-none');
        });

        productBox.addEventListener('mouseout', () => {
            sale?.classList.remove('d-none');
            buttons?.classList.add('d-none');

            variantsSummary?.classList.remove('d-none');
            variants?.classList.add('d-none');

            divider?.classList.remove('d-none');
            title?.classList.remove('d-none');
            about?.classList.remove('d-none');
        });
    });
}
